import React from 'react';
import WatchReview from '../watchReview'


function AdamsApples(props) {

        return (
            <WatchReview 
                tube="https://www.youtube.com/embed/nsl9CSbNblM" 
                blerb="Welcome to Brothers Sip and Talk Shit, where we discuss all things horror and foreign...films. Over our next drink, we discuss a last minute foreign pick, black comedy 'Adams Apples'...It was....interesting"
            />
        )
    }   

export default AdamsApples;
